// extracted by mini-css-extract-plugin
export default {"container":"_ec0a9602"};